export class LogoInstrument {
    public content: string;
    public logoID: string;
    public type: string;
}
